import { render, staticRenderFns } from "./page-agv-rules.vue?vue&type=template&id=52aa33f0&scoped=true&lang=pug&"
import script from "./page-agv-rules.vue?vue&type=script&lang=js&"
export * from "./page-agv-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa33f0",
  null
  
)

export default component.exports